import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { LOAD_BOARDS, LOAD_DEFAULT_BOARD_ID, LOAD_BOARD_CLIENTS, LOAD_BOARD_COLLABORATORS, RESET_CURRENT_SEARCH, LOAD_CUSTOM_FIELDS_DEFINITIONS, LOAD_CLIENT_PROFILES_WITH_CHANGES } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { LOAD_REFERRERS } from "../../../referrers/store/referrer-actions";
import { LOAD_AGENTS } from "../../../../agents/store/agent-actions";
import ClientBoardHeader from "./client-board-header";
import ClientBoardDynamicContainer from "./views-type/dynamic/client-board-dynamic-container";
import ClientBoardClassicContainer from "./views-type/classic/client-board-classic-container";
import Amplitude from "../../../../../../../shared/utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientBoardContainer",
  title() {
    return this.selectedBoardName;
  },
  components: {
    ClientBoardHeader,
    ClientBoardDynamicContainer,
    ClientBoardClassicContainer,
    // Lazy load heavy/rarely-used components
    AddStateModal: () => import("./modals/add-state-modal"),
    BoardDetailsModal: () => import("./modals/board-details-modal"),
    DeleteBoardModal: () => import("./modals/delete-board-modal"),
    EmailTrackingModal: () => import("./modals/email-tracking-modal"),
    ManageCollaboratorsModal: () => import("./modals/manage-collaborators-modal"),
    ManageVisibilityModal: () => import("./modals/manage-visibility-modal"),
    ClientBoardChartContainer: () => import("./views-type/chart/client-board-chart-container.vue"),
    BoardChangelog: () => import("./changelog/board-changelog"),
    RemoveSelfAsCollaboratorModal: () => import("./modals/remove-self-as-collaborator-modal.vue")
  },
  props: {
    boardId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      loading: true,
      showBoardChangelog: false,
      boardLoadTimeMs: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", ["defaultBoardId", "boards"])), mapState("AccountStore", ["clientBoardView"])), mapFields("BoardStore", ["selectedBoardId"])), mapFields("AccountStore", {
    localDefaultBoardId: "boardId"
  })), mapGetters("BoardStore", [BOARDS])), {}, {
    isDynamicView() {
      return this.clientBoardView === "dynamic";
    },
    isClassicView() {
      return this.clientBoardView === "classic";
    },
    isChartView() {
      return this.clientBoardView === "chart";
    },
    selectedBoardName() {
      var _this$boards$byId$thi, _this$boards$byId$thi2;
      return (_this$boards$byId$thi = this.boards.byId[this.selectedBoardId]) != null && _this$boards$byId$thi.name ? `${(_this$boards$byId$thi2 = this.boards.byId[this.selectedBoardId]) == null ? void 0 : _this$boards$byId$thi2.name} - ${this.$t("sidebar.sections.board")}` : this.$t("sidebar.sections.board");
    }
  }),
  watch: {
    async selectedBoardId(value, oldValue) {
      if (oldValue && value !== oldValue) {
        const boardLoadStartedAt = performance.now();
        this.resetFilters();
        await this.LOAD_CUSTOM_FIELDS_DEFINITIONS({
          boardId: value
        });
        await _Promise.all([this.LOAD_BOARD_CLIENTS({
          boardId: value
        }).then(() => this.LOAD_CLIENT_PROFILES_WITH_CHANGES({
          boardId: value
        })), this.LOAD_BOARD_COLLABORATORS({
          boardId: value
        })]);
        this.boardLoadTimeMs = Math.round(performance.now() - boardLoadStartedAt);
      }
      this.localDefaultBoardId = value;
      if (!this.loading) this.logAmplitudeVisited();
    },
    clientBoardView() {
      this.logAmplitudeVisited();
    }
  },
  beforeDestroy() {
    this.resetFilters();
  },
  deactivated() {
    this.resetFilters();
  },
  activated() {
    this.init();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AgentStore", [LOAD_AGENTS])), mapActions("ReferrerStore", [LOAD_REFERRERS])), mapActions("BoardStore", [LOAD_BOARDS, LOAD_DEFAULT_BOARD_ID, LOAD_BOARD_CLIENTS, LOAD_BOARD_COLLABORATORS, RESET_CURRENT_SEARCH, LOAD_CUSTOM_FIELDS_DEFINITIONS, LOAD_CLIENT_PROFILES_WITH_CHANGES])), {}, {
    async init() {
      const boardLoadStartedAt = performance.now();
      if (!this.BOARDS.length) await this.LOAD_BOARDS();
      await this.LOAD_DEFAULT_BOARD_ID();
      this.selectedBoardId = this.localDefaultBoardId || this.defaultBoardId;
      // Fetch only the minimum data for initial render in parallel
      await _Promise.all([this.LOAD_CUSTOM_FIELDS_DEFINITIONS({
        boardId: this.selectedBoardId
      }), this.LOAD_BOARD_CLIENTS({
        boardId: this.selectedBoardId
      })]);
      this.$setTitle();
      this.loading = false;
      // Defer loading of secondary data
      await this.loadSecondaryData();
      this.boardLoadTimeMs = Math.round(performance.now() - boardLoadStartedAt);
      this.logAmplitudeVisited();
    },
    async loadSecondaryData() {
      // These can be loaded in the background after initial render
      try {
        await _Promise.all([this.LOAD_BOARD_COLLABORATORS({
          boardId: this.selectedBoardId
        }), this.LOAD_REFERRERS(), this.LOAD_AGENTS(), this.LOAD_CLIENT_PROFILES_WITH_CHANGES({
          boardId: this.selectedBoardId
        })]);
      } catch (e) {
        // Handle errors if needed
      }
    },
    handleCollaboratorChange() {
      this.LOAD_BOARD_CLIENTS({
        boardId: this.selectedBoardId
      });
    },
    resetFilters() {
      this.RESET_CURRENT_SEARCH();
    },
    handleChangelogSummary() {
      this.showBoardChangelog = true;
    },
    logAmplitudeVisited() {
      Amplitude.logEvent(`Board - visited ${this.clientBoardView}`, {
        data: {
          boardId: this.selectedBoardId,
          boardLoadTimeMs: this.boardLoadTimeMs
        }
      });
    },
    async handleChangeBoard() {
      this.$setTitle();
    }
  })
});